export type OidcIdentity = { issuer: string; clientId: string };

export async function loadOidcIdentity(
  production: boolean,
  development: OidcIdentity,
  fetcher: typeof fetch = fetch,
): Promise<OidcIdentity> {
  if (!production) return development;
  const response = await fetcher('/runtime-config.json', { cache: 'no-store' });
  if (!response.ok) throw new Error('OIDC runtime configuration unavailable');
  const data: unknown = await response.json();
  if (
    !data ||
    typeof data !== 'object' ||
    !('issuer' in data) ||
    !('clientId' in data) ||
    typeof data.issuer !== 'string' ||
    typeof data.clientId !== 'string' ||
    !/^https:\/\/auth\.onig\.eu\/application\/o\/[a-z0-9-]+\/$/.test(data.issuer) ||
    !/^[A-Za-z0-9_-]+$/.test(data.clientId)
  ) {
    throw new Error('Invalid OIDC runtime configuration');
  }
  return { issuer: data.issuer, clientId: data.clientId };
}
